export const OFFLINE_DB_NAME_KEY = "fr_offline_active_db";

export function resolveRepoIdentity(user) {
  const userId = String(user?.id || user?._id || "").trim();
  const rawCompany = user?.companyId;
  const companyId = String(
    rawCompany?._id || rawCompany?.id || rawCompany || ""
  ).trim();
  return { userId, companyId };
}

export function offlineDbName(userId, companyId) {
  return `fr-offline-v1-${userId}-${companyId}`;
}

export function rememberOfflineDbName(name) {
  try {
    if (name) window.localStorage.setItem(OFFLINE_DB_NAME_KEY, name);
    else window.localStorage.removeItem(OFFLINE_DB_NAME_KEY);
  } catch {
    /* ignore */
  }
}

export function readRememberedOfflineDbName() {
  try {
    return window.localStorage.getItem(OFFLINE_DB_NAME_KEY) || "";
  } catch {
    return "";
  }
}
